import { useWorker } from '@koale/useworker';
import { Download, Save } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components';
import { CREDENTIALS_CREATE } from '../../routes';
import {
  useDispatch,
  useSelector,
  clearCredentials,
  credentialsListSlice,
  fetchCredentialsExportExcel,
  fetchCredentialsExportHtml,
} from '../../stores';
import {
  exportCredentialsToCSV,
  handleApiDataCredentialsToCSV,
} from './ExportCredentialsToCSV';
import {
  exportCredentialsToHTML,
  handleApiDataCredentialsToHTML,
} from './ExportCredentialsToHTML';

export const CredentialsTableToolbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const credentialsFiltersValues = useSelector(
    (state) => state.credentialsFiltersValuesReducer,
  );
  const routesRaw = useSelector(
    (state) => state.credentialsFiltersReducer.routes,
  );
  // Map routes to the correct type for the export handler
  const routes = routesRaw.map((r: any) => ({
    id: String(r.id),
    value: r.name || r.value,
  }));
  const { credentialsExportExcelLoading, credentialsExportHtmlLoading } =
    useSelector(
      (state: { credentialsListSliceReducer: any }) =>
        state.credentialsListSliceReducer,
    );
  const [exportCredentialsToCSVWorker] = useWorker(
    handleApiDataCredentialsToCSV,
  );
  const [exportCredentialsToHTMLWorker] = useWorker(
    handleApiDataCredentialsToHTML,
  );

  const handleExportExcel = () => {
    const params = {
      number: credentialsFiltersValues.number,
      licensePlate: credentialsFiltersValues.licensePlate,
      holderName: credentialsFiltersValues.holderName,
      holderDocument: credentialsFiltersValues.holderDocument,
      street: credentialsFiltersValues.street,
      routeId: credentialsFiltersValues.routeId,
      expirationDate: credentialsFiltersValues.expirationDate,
      status: credentialsFiltersValues.status,
    };

    dispatch(fetchCredentialsExportExcel(params)).then((res) => {
      if (res.type == 'credentialsExportExcel/fulfilled' && res.payload) {
        // Fix: pass only the array to the export handler
        let data: any[] = [];
        if (Array.isArray(res.payload)) {
          data = res.payload;
        } else if (
          res.payload &&
          typeof res.payload === 'object' &&
          'page' in res.payload &&
          Array.isArray(res.payload.page)
        ) {
          data = res.payload.page;
        } else {
          data = [];
        }
        exportCredentialsToCSV(data, routes, dispatch, (apiData, routes) =>
          Promise.resolve(handleApiDataCredentialsToCSV(apiData, routes)),
        );
      }
    });
  };

  const handleExportHtml = () => {
    const params = {
      number: credentialsFiltersValues.number,
      licensePlate: credentialsFiltersValues.licensePlate,
      holderName: credentialsFiltersValues.holderName,
      holderDocument: credentialsFiltersValues.holderDocument,
      street: credentialsFiltersValues.street,
      routeId: credentialsFiltersValues.routeId,
      expirationDate: credentialsFiltersValues.expirationDate,
      status: credentialsFiltersValues.status,
    };

    dispatch(fetchCredentialsExportHtml(params)).then((res) => {
      if (res.type == 'credentialsExportHtml/fulfilled' && res.payload) {
        // Fix: pass only the array to the export handler
        let data: any[] = [];
        if (Array.isArray(res.payload)) {
          data = res.payload;
        } else if (
          res.payload &&
          typeof res.payload === 'object' &&
          'page' in res.payload &&
          Array.isArray(res.payload.page)
        ) {
          data = res.payload.page;
        } else {
          data = [];
        }
        exportCredentialsToHTML(data, routes, dispatch, (apiData, routes) =>
          Promise.resolve(handleApiDataCredentialsToHTML(apiData, routes)),
        );
      }
    });
  };

  return (
    <Grid container margin={2} justifyContent='space-between'>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Button
          variant='contained'
          label='Exportar em excel'
          startIcon={<Download />}
          onClick={() => handleExportExcel()}
          loading={credentialsExportExcelLoading}
        />
        <Button
          variant='contained'
          label='Exportar em html'
          startIcon={<Download />}
          onClick={() => handleExportHtml()}
          loading={credentialsExportHtmlLoading}
        />
      </div>
      <Button
        variant='contained'
        label='Cadastrar nova credencial'
        startIcon={<Save />}
        onClick={() => {
          dispatch(clearCredentials());
          navigate(CREDENTIALS_CREATE);
        }}
      />
    </Grid>
  );
};
